import React from "react";
import "../About/Aboutus.css";

const OurStoryPreview = ({ previewService, setShowPreviewOurStory }) => {
    const s = previewService;
    if (!s) return null;

    return (
        <div className="os-overlay" onClick={() => setShowPreviewOurStory(false)}>
            <div className="os-modal" onClick={(e) => e.stopPropagation()}>

                {/* Close Button */}
                <button className="os-close" onClick={() => setShowPreviewOurStory(false)}>
                    ✕
                </button>

                <div className="os-container">

                    {/* TOP TEXT SECTION */}
                    <h1 className="os-mini-title">{s.heading}</h1>
                    <h1 className="os-subtitle">{s.title}</h1>
                    <div
                        className="os-description"
                        dangerouslySetInnerHTML={{ __html: s.description }}
                    />

                    {/* 3 CARDS */}
                    <div className="os-card-wrapper">
                        {s.sectionsData && s.sectionsData.map((sec, index) => (
                            <div key={index} className="os-card">
                                <h2 className="os-card-heading">{sec.heading}</h2>
                                <div
                                    className="os-card-text"
                                    dangerouslySetInnerHTML={{ __html: sec.description }}
                                />

                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default OurStoryPreview;
